/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Role } from '../../models/role';

export interface ApiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Params {
  userId?: string;
  Authorization?: string;
}

export function apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetAdminClientRoleMappingsForUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Role>>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Role>>;
    })
  );
}

apiKeycloakGetAdminClientRoleMappingsForUserGet$Plain.PATH = '/api/keycloak/GetAdminClientRoleMappingsForUser';
